exports = module.exports = require("../../../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stat-holder {\n    background-color: #fafafa !important;\n    margin: 10px !important;\n    max-width: 270px !important;\n}\n\n.stat-holder > div {\n    width: 100%;\n    min-width: 250px !important;\n    min-height: 100px !important;\n    padding: 15px;\n}\n\n.stat-holder * {\n    color: rgb(114, 114, 114) !important;\n}\n\n.stat-holder i {\n    font-size: 36px;\n}\n\n.accent {\n    color: #10b364 !important;\n}\n\n@media only screen and (min-width: 600px) {\n    \n}\n  \n@media only screen and (min-width: 768px) {\n}", ""]);

// exports
